// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"g7-z"};